import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/shared/components/ui/alert-dialog'
import { CHAT_COPY } from '@/entities/chat'

export function DeleteMessageDialog({
  open,
  onOpenChange,
  onConfirm,
  isPending,
  error,
  internal,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  isPending: boolean
  error: string | null
  internal: boolean
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{CHAT_COPY.deleteConfirmTitle}</AlertDialogTitle>
          <AlertDialogDescription>
            {internal ? CHAT_COPY.deleteConfirmBodyInternal : CHAT_COPY.deleteConfirmBody}
          </AlertDialogDescription>
        </AlertDialogHeader>
        {error && <p className="text-[12.5px] text-bad">{error}</p>}
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending}>{CHAT_COPY.deleteCancel}</AlertDialogCancel>
          <AlertDialogAction
            disabled={isPending}
            onClick={(event) => {
              event.preventDefault()
              onConfirm()
            }}
          >
            {CHAT_COPY.deleteConfirmAction}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
